module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/sold_out_icon-f864bd951b13a5e7c7c6acb239dd3bf5.png";